export const mutations = {
  setFuncionario(state, funcionario) {
    state.funcionario = funcionario;
  },
  setFuncionarios(state, funcionarios) {
    state.funcionarios = funcionarios;
  },
  addFuncionario(state, data) {
    state.funcionarios.push(data);
  },
  removeFuncionario(state, data) {
    let index = state.funcionarios.map((x) => x.id).indexOf(data.id);
    state.funcionarios.splice(index, 1);
  },
  setModalCadastrarFuncionario(state, status) {
    state.modalCadastrarFuncionario = status;
  },
  setModalExcluirFuncionario(state, status) {
    state.modalExcluirFuncionario = status;
  },
  setModalPermissaoFuncionario(state, status) {
    state.modalPermissaoFuncionario = status;
  },
  setPermissaoFuncionario(state, data) {
    state.permissaoFuncionario = data;
  },
  setSalariosFuncionario(state, salarios) {
    state.funcionario.salarios = salarios
  },
  setDependentesFuncionario(state, dependentes) {
    state.funcionario.dependentes = dependentes
  },
  setDependente(state, dependente) {
    state.dependente = dependente
  },
  setSalario(state, salario) {
    state.salario = salario
  },
  setDependentes(state, dependente) {
    state.dependentes = dependente
  },
  setSalarios(state, salario) {
    state.salarios = salario
  }
};

export default {};
